import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { Interceptor } from './login/http.interceptor';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppComponent } from './app.component';
import { AuthGuard } from './auth.guard';
import { AppRoutingModule } from './app-routing.module';
import { NotFoundComponent } from './error/not-found/not-found.component';
import { AddSiteComponent } from './system-management/regions/modals/add-site/add-site.component';

import { PortTypePipe } from './pipes/port-type.pipe';
import { PortIconPipe } from './pipes/port-icon.pipe';
import { AlarmLevelPipe } from './pipes/alarm-level.pipe';
import { AlarmTypePipe } from './pipes/alarm-type.pipe';
import { AlarmSchemaPipe } from './pipes/alarm-schema.pipe';
import { AlarmObjTypePipe } from './pipes/alarm-obj-type.pipe';
import { LoginModule } from './login/login.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ProxyRouteComponent } from './proxy-route.component';
import { TableChangeDirective } from './table-change.directive';
import { ListItemComponent } from './utils/list-item/list-item.component';
import { ListComponent } from './utils/list/list.component';


@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    AddSiteComponent,

    ProxyRouteComponent,

    TableChangeDirective,

    ListItemComponent,

    ListComponent,






  ],
  entryComponents:[
    AddSiteComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,


    HttpClientModule,
    FlexLayoutModule,
    LoginModule,
    AppRoutingModule
    
  ],
  providers: [

    PortIconPipe,
    PortTypePipe,
    AlarmLevelPipe,
    AlarmTypePipe,
    AlarmSchemaPipe,
    AlarmObjTypePipe,
    AuthGuard, {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
